export default __webpack_public_path__ + "static/media/lemontbotanique_s1.ad4dfd79.png";